export const laoToThaiconsonants = {
    'ແ': 'แ',
    'າ': 'า',
    'ກ': 'ก',
    'ຂ': 'ข',
    'ຄ': 'ค',
    'ງ': 'ง',
    'ຈ': 'จ',
    'ສ': 'ส',
    'ຊ': 'ช',
    'ຍ': 'ญ',
    'ດ': 'ด',
    'ຕ': 'ต',
    'ຖ': 'ถ',
    'ທ': 'ท',
    'ນ': 'น',
    'ບ': 'บ',
    'ປ': 'ป',
    'ຜ': 'ผ',
    'ຝ': 'ฝ',
    'ພ': 'พ',
    'ຟ': 'ฟ',
    'ມ': 'ม',
    'ຢ': 'ย',
    'ຣ': 'ร',
    'ລ': 'ล',
    'ວ': 'ว',
    'ຫ': 'ห',
    'ອ': 'อ',
    'ຮ': 'ฮ',
};